import { Flex } from '@/components/priority/Flex/Flex'
import { Text } from '@/components/priority/Text/Text'
import { usePdfIndicators } from '@/hooks/pdf/usePdfIndicators'
import { useTranslation } from 'react-i18next'
import * as S from '@/components/pdfRender/PdfRender.styled'
import { PdfStatusKey } from '@messenger/types'

type PdfViewerSkeletonProps = {
  pdfGenerationStatus: PdfStatusKey
  pdfGenerationProgress: number
  isProof?: boolean
}

export const PdfViewerSkeleton = ({
  pdfGenerationStatus,
  pdfGenerationProgress,
  isProof = false,
}: PdfViewerSkeletonProps) => {
  const { firstDotActive, secondDotActive, thirdDotActive, fourthDotActive } =
    usePdfIndicators(pdfGenerationProgress)
  const { t } = useTranslation()

  const pdfStatusMessages: Record<PdfStatusKey, string> = {
    IN_QUEUE: t('pdf.inQueueText'),
    GENERATING: t('pdf.generatingText'),
    COMPLETE: t('pdf.completeText'),
    TIMEOUT: t('pdf.timeoutText'),
    ERROR: t('pdf.errorText'),
    PROOF_ONLY: t('pdf.generatingText'),
  }

  const proofStatusMessages: Record<PdfStatusKey, string> = {
    IN_QUEUE: t('pdf.proofInQueueText'),
    GENERATING: t('pdf.proofGeneratingText'),
    COMPLETE: t('pdf.proofCompleteText'),
    TIMEOUT: t('pdf.proofTimeoutText'),
    ERROR: t('pdf.proofErrorText'),
    PROOF_ONLY: t('pdf.proofGeneratingText'),
  }

  const statusMessages = isProof ? proofStatusMessages : pdfStatusMessages
  const fallback = isProof
    ? t('pdf.proofGeneratingText')
    : t('pdf.generatingText')
  const skeletonStatusText = statusMessages?.[pdfGenerationStatus] || fallback

  return (
    <Flex
      width="100%"
      height="100%"
      justify="center"
      align="center"
      background="white"
    >
      <Flex column align="center" gap="24px">
        <Text weight="500" size="24px" align="center" color="almostBlack">
          {skeletonStatusText}
        </Text>
        <Flex gap="24px">
          <Flex gap="24px">
            <S.Indicator $active={firstDotActive} />
            <S.Indicator $active={secondDotActive} />
            <S.Indicator $active={thirdDotActive} />
            <S.Indicator $active={fourthDotActive} />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}
